import React, { memo } from "react";

import { AdminConsole } from "Components/AdminConsole/AdminConsole";
import { AdminConsoleTabs } from "Components/AdminConsole/AdminConsoleTabs";
import {
  AdminConsoleBodyStyled,
  AdminPageStyled,
} from "Components/AdminConsole/styles";

export const AdminConsolePage = memo(() => (
  <AdminPageStyled data-test-id="admin_page">
    <AdminConsoleTabs active="users" />
    <AdminConsoleBodyStyled data-test-id="admin_console_body">
      <AdminConsole />
    </AdminConsoleBodyStyled>
  </AdminPageStyled>
));
